module.exports = __webpack_public_path__ + "img/bg-daniel-steinberg.e36e0119.jpg";